import { combineReducers } from '@reduxjs/toolkit';
import auth from './reducers/auth/reducer';
import user from './reducers/user/reducer';
import settings from './reducers/settings/reducer';
import dashboard from './reducers/dashboard/reducer';
import orders from './reducers/orders/reducer';
import refunds from './reducers/refunds/reducer';
import ordersSync from './reducers/ordersSync/reducer';
import invoices from './reducers/invoices/reducer';
import reports from './reducers/reports/reducer';
import vatCorrections from './reducers/vatCorrections/reducer';
import paymentMethods from './reducers/paymentMethods/reducer';
import payments from './reducers/payments/reducer';
import transactions from './reducers/transactions/reducer';
import pricing from './reducers/pricing/reducer';
import shipments from './reducers/shipments/reducer';
import gpsr from './reducers/gpsr/reducer';
import eudr from './reducers/eudr/reducer';
import euDdp from './reducers/euDdp/reducer';
import publicAttachment from './reducers/publicAttachment/reducer';
import emExports from './reducers/emExports/reducer';
import ppwr from './reducers/ppwr/reducer';
import shopifyApps from './reducers/shopifyApps/reducer';

const rootReducer = combineReducers({
	auth,
	user,
	settings,
	dashboard,
	orders,
	refunds,
	ordersSync,
	invoices,
	reports,
	vatCorrections,
	paymentMethods,
	payments,
	transactions,
	pricing,
	shipments,
	gpsr,
	eudr,
	euDdp,
	publicAttachment,
	emExports,
	ppwr,
	shopifyApps,
});

export default rootReducer;
